import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8887663e")

_pushScopeId("data-v-8887663e")
const _hoisted_1 = { class: "absolute bottom-14 left-0 w-full" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "bg-white rounded-lg drop-shadow-md triangle mx-4 p-4",
      style: _ctx.inputCssVars
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4)
  ]))
})